import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import * as FileSaver from 'file-saver';

@Injectable()
export class FileUtilityService {

    constructor(public http$: HttpClient) { }

    /**
     * This is a utility method to upload single file to a given upload path
     */
    public uploadFile(file: File, fileUploadPath: string) {
        // const headers = new Headers();
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }) };
        const formData = new FormData();
        formData.append('file', file);
        const response$ = this.http$.post(fileUploadPath, formData, options).map((response: any) => {
            return response;
        }).catch((error: any) => {
            if (error.error.length !== 0) {
                if (error.error.statusCode !== 200) {
                    return Observable.throw(error.error.statusMessage);
                }
            }
        });
        return response$;
    }
    /**
     * This is a utility method to upload multiple files to a given upload path
     */
    public uploadFiles(files: File[], fileUploadPath: string) {
        // const headers = new Headers();
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }) };
        const formData = new FormData();
        for (const file of files) {
            formData.append('file', file);
        //    console.log(file);
        }
        const response$ = this.http$.post(fileUploadPath, formData, options).map((response: any) => {
            return response;
        }).catch((error: any) => {
            if (error.error.length !== 0) {
                if (error.error[0].statusCode !== 200) {
                    return Observable.throw(error.error[0].statusMessage);
                }
            }
        });
        return response$;
    }

    /**
     * This is a utility method to download file from the given path
     */
    public downloadFile(fileDownloadPath: string) {
        const response$ = this.http$.get('file' + fileDownloadPath, { responseType: 'blob' }).map((response: any) => {
            return response;
        }).catch((error: any) => {
            if (error.error.length !== 0) {
                if (error.error.statusCode !== 200) {
                    return Observable.throw(error.error.statusMessage);
                }
            }
        });
        return response$;
    }

    /**
     * This method saves the given file to the local drive. It currently wraps the file saver library
    */
    public saveFileLocally(file: any, fileName?: string) {
        FileSaver.saveAs(file, fileName);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/file-utility.service.ts